let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eJ59I")).then(() => parcelRequire('FPgIe'));